import React, { useState } from "react";
import Token from "../../images/bigodToken.webp";
import AnimatedCircuitRight from "../AnimatedCircuit/AnimatedCircuitright";
import BorderRayCircuit from "../BorderRay/borderRay";
import AnimatedCircuitLeft from "../AnimatedCircuit/AnimatedCircuit";
import arcImage from "../../images/cloclwise.svg";
import arcImage1 from "../../images/anticlockwise.svg";
import star1 from "../../images/Star1.svg";
import star2 from "../../images/star2.svg";
import star3 from "../../images/star3.svg";
import tokenbehind from "../../images/tokenbehind.png";
import { Link } from "react-router-dom";
import TokenPrice from "../TokenPriceCOmponent/tokenPrice";
import toast from "react-hot-toast";
import { FaRegCopy } from "react-icons/fa";

const HeroSection = () => {
  const [copied, setCopied] = useState(false);
  const contractAddress = "0x11526f93be5f26220e9c7eacb587edaebaa9f627";

  const handleCopy = () => {
    navigator.clipboard.writeText("0x11526f93be5f26220e9c7eacb587edaebaa9f627");
    toast.success("Contract address copied to clipboard!");
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <div
      className="md:mt-[88px] mt-[40px]"
      style={{
        background: `
      radial-gradient(circle at 20% 20%, rgba(4, 69, 114, 0.2) 0%, transparent 50%),
      radial-gradient(circle at 80% 20%, rgba(4, 69, 114, 0.2) 0%, transparent 50%),
      radial-gradient(circle at center, rgba(4, 69, 114, 0.4) 0%, rgba(0, 0, 0, 1) 80%)
      `,
        backgroundColor: "#000",
      }}
    >
      <div className="flex justify-center items-center md:mt-5 mt-14">
        <TokenPrice />
      </div>

      <div className="flex flex-col sm:flex-row md:flex-row  md:justify-between justify-center items-center  md:items-start text-white py-10">
        <div className="hidden sm:block md:block relative sm:-top-[90px] md:-top-[38px] ">
          <AnimatedCircuitLeft />
        </div>
        <div className="flex flex-col gap-[14px] justify-center items-center text-center w-full max-w-3xl">
          <div className="relative w-72  md:w-[390px] h-72  md:h-[390px] mx-auto mb-6 top-5 ">
            <img
              src={arcImage}
              alt=""
              aria-hidden="true"
              width="390"
              height="390"
              decoding="async"
              loading="lazy"
              className="absolute inset-0 m-auto w-full h-full animate-spin-slow z-20"
            />
            <img
              src={arcImage1}
              alt=""
              aria-hidden="true"
              width="325"
              height="325"
              decoding="async"
              loading="lazy"
              className="absolute inset-0 m-auto w-5/6 h-5/6 animate-spin-reverse-slow z-20"
            />
            <img
              src={tokenbehind}
              alt=""
              aria-hidden="true"
              width="260"
              height="260"
              decoding="async"
              loading="lazy"
              className="absolute inset-0 m-auto w-4/6 h-4/6 z-30 "
            />
            <img
              src={Token}
              alt="BIGOD Coin"
              width="304"
              height="304"
              decoding="async"
              loading="eager"
              fetchpriority="high"
              className="absolute inset-0 m-auto w-[78%] h-[78%] -top-2 -left-1  z-30"
            />
            <img
              src={star1}
              alt=""
              width="40"
              height="40"
              decoding="async"
              loading="lazy"
              className="absolute top-2 -right-16  animate-blink [animation-delay:.5s]   z-30 md:block hidden"
            />
            <img
              src={star2}
              alt=""
              width="40"
              height="40"
              decoding="async"
              loading="lazy"
              className="absolute top-20 -left-12  animate-blink [animation-delay:.5s] z-30 md:block hidden"
            />
            <img
              src={star3}
              alt=""
              width="40"
              height="40"
              decoding="async"
              loading="lazy"
              className="absolute top-16 -right-36 animate-blink [animation-delay:.5s]   z-30 md:block hidden"
            />
          </div>

          <div className="mt-2 p-[2px] h-[42px] w-[234px] rounded-md bg-[linear-gradient(86.92deg,#37ABFF_11.12%,rgba(255,255,255,0.2)_81.99%)]">
            <Link to="https://investor.bingold.to/login" target="_self">
              <button className="bg-[#ffd700] text-black h-[38px] w-full rounded-md font-semibold text-sm tracking-wide">
                JOIN TODAY
              </button>
            </Link>
          </div>
          <div className="mt-6 flex  flex-col    md:items-center gap-3 rounded-full ">
            <span className="text-white font-medium md:text-lg  text-base">
              Contract Address:
            </span>
            <div className="border rounded-full border-white px-2 py-2 flex items-center  gap-2 ">
              <span className="text-white font-medium md:text-base text-xs ">
                {contractAddress}
              </span>
              <button onClick={handleCopy}>
                <FaRegCopy className="text-white hover:text-gray-300 cursor-pointer text-base" />
              </button>
            </div>
          </div>
          <BorderRayCircuit />
          <h1 className="text-[22px]  md:text-[25px] font-bold text-[#18B6F2]">
           Safest Way to Own Gold
          </h1>
          <p className="text-lg  md:text-[20px] font-semibold text-white mb-1 ">
          - BIGOD is a gold backed token built for trust & Stability
          </p>
          <p className="text-sm  md:text-[17px] font-semibold text-white mb-1 ">
            {" "}
          Across history, gold stood as a symbol of worth and strength. Even today, in economic stress and market queries, gold remains a  preferred asset for long term wealth protection. 
          </p>
         {/* <div className="flex juctify-center items-center gap-6 mt-4">
           <div className="mt-2 p-[2px] h-[42px] w-[234px] rounded-md bg-[linear-gradient(86.92deg,#37ABFF_11.12%,rgba(255,255,255,0.2)_81.99%)]">
            <Link to="https://investor.bingold.to/login" target="_self">
              <button className="bg-[#ffd700] text-black h-[38px] w-full rounded-md font-semibold text-sm tracking-wide">
                JOIN TODAY
              </button>
            </Link>            
          </div>
          <div className="mt-2 p-[2px] h-[42px] w-[234px] rounded-md bg-[linear-gradient(86.92deg,#37ABFF_11.12%,rgba(255,255,255,0.2)_81.99%)]">
            <Link to="https://investor.bingold.to/login" target="_self">
              <button className="bg-[#ffd700] text-black h-[38px] w-full rounded-md font-semibold text-sm tracking-wide">
                About
              </button>
            </Link>            
          </div>
         </div> */}
        </div>
        <div className="hidden sm:block md:block relative sm:-top-[90px] md:-top-[38px]  ">
          <AnimatedCircuitRight />
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
